import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_CLIENT_DETAILS_V2, GET_CLIENT_DETAILS_V2_SUCCESS, GET_CLIENT_DETAILS_V2_ERROR } from '../../actions';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';

function* getClientDetailsV2({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/client/${payload?.urlParams?.clientId}`,
      method: 'GET',
      params: payload?.urlParams,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_CLIENT_DETAILS_V2_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);

      yield put({
        type: GET_CLIENT_DETAILS_V2_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_CLIENT_DETAILS_V2_ERROR, payload: error });
  }
}

export function* watchGetClientDetailsV2() {
  yield takeEvery(GET_CLIENT_DETAILS_V2, getClientDetailsV2);
}

function* getClientDetailsV2Saga() {
  yield all([fork(watchGetClientDetailsV2)]);
}

export default getClientDetailsV2Saga;
